module.exports = __webpack_public_path__ + "static/media/80s.001dd58e.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/80s.png
// module id = 641
// module chunks = 0 1